import type { HTMLAttributes } from 'react'

type Variant = 'glass' | 'glass2' | 'plain'

export function Card(props: HTMLAttributes<HTMLDivElement> & { variant?: Variant }) {
  const { variant = 'glass', className, ...rest } = props
  const variants: Record<Variant, string> = {
    glass: 'glass',
    glass2: 'glass2',
    plain: 'rounded-2xl border border-white/10 bg-white/5',
  }
  return <div {...rest} className={[variants[variant], className].filter(Boolean).join(' ')} />
}

